export default {
  // 按钮文本
  buttons: {
    payNow: '立即支付',
  },

  // 错误消息
  messages: {
    unexpectedError: '抱歉，发生了一点意外错误，请稍后再试或联系客服。',
  },

  // 开发注释
  dev: {
    paymentMethodsNote: '可用支付方式将根据客户所在地区、订单金额和币种动态展示。',
    previewLink: '按交易预览可用支付方式',
  },
};
